module.exports = __webpack_public_path__ + "media/src/images/abouts/devices/01-75bc8a53822a3575e6f8a8e4aa0fb612.png";